import { Link } from "react-router-dom";

const Warehouse = () => {
  return (
    <div>
      <div className="flex flex-col justify-center items-center">
      <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">
         
          <div className="flex flex-col justify-center">
            <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
              Warehousing 
            </h1>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
              TCS offers state-of-the-art, dedicated as well as multi-user warehousing, with over 650,000 square feet of 
              space in Pakistan. The inventory management and warehousing processes are automated. We also offer a 
              Web-based Inventory Management System (WIMS), which provides real-time online information to customers 
              for ordering, monitoring and managing their stocks efficiently. 
            </p>
            
                <div className=" mt-[1rem] w-[100%]">
                        
                  <div className="flex justify-left ">
                      <Link to="/warehousing" className="flex justify-center text-center items-center h-9 mt-[2px] rounded-sm text-white bg-[#D40511] border border-[#F21E26] w-[10rem] rounded-md mt-[1rem] p-1 h-[2.5rem] text-sm hover:bg-[#F21E26] hover:text-white transition-all duration-500">Find Out More</Link>
                      
                  </div>
                </div>
          </div>
          
          <div className="flex-1 flex flex-col justify-center items-center sm:mt-[0rem] mt-[1rem] ">
            <img src="/DomesticScrollingBanner/scrolling-image20.jpg" alt="" className="rounded-md max-w-[100%]"/>
          </div>
        </div>
        
      </div>

      
    </div>
  );
};

export default Warehouse;
